/// <reference types="@types/googlemaps" />
import { Injectable, SecurityContext } from '@angular/core'
import { environment } from '../../environments/environment';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { HttpClient } from '@angular/common/http';
import { PlaceResult } from 'globals/store/programs.data';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class LocationService { 

  readonly api = `${environment.functionsURL}api/app`;
  readonly webAPIKey = environment.firebase.apiKey
  readonly serverAPIKey = environment.serverGoogleApiKey
  readonly _file = 'locations.service.ts'

  constructor(private sanitizer: DomSanitizer, private http: HttpClient) { 
    // console.log({ environment, serverAPIKey: this.serverAPIKey })
  }

  private async findPlacesFromQuery(request: google.maps.places.FindPlaceFromQueryRequest): Promise<google.maps.places.PlaceResult[]> {
    // if (!this. placeService) placeService = new google.maps.places.PlacesService(document.createElement('div'))
    const placeDiv = document.createElement("div")
    placeDiv.classList.add('places-Service-Searcher')
    const placeService = new google.maps.places.PlacesService(placeDiv)

    return new Promise((resolve,reject)=> placeService.findPlaceFromQuery(request, (
          results: google.maps.places.PlaceResult[],
          status: google.maps.places.PlacesServiceStatus
        ) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) resolve(results) 
          else reject(status)  
        }
      )
    )
  }
  
  private checkForServerApiKey() {
    if (!this.serverAPIKey) throw new Error('Need to add a server api key to environment.serverGoogleApiKey!')
  }

  async getTimeZoneFromLatLongDate(lat: number, lng: number, date: Date = null) {
    this.checkForServerApiKey()
    if (!date) date = new Date()
    if (!lat || !lng) throw new Error ('Need latitude and longitude to get timezone from Google API')
    const seconds = Math.round(date.getTime()/1000)
    const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${seconds}&key=${this.serverAPIKey}`
    console.log(`Get timezone request url:\n${url}`)
    const response = await fetch(url)
    if (response.ok){
      const { timeZoneId, dstOffset, rawOffset } = await response.json()
      return { timeZoneId, dstOffset, rawOffset }
    } else {
      console.log(response)
      return { timeZoneId:null, dstOffset:null, rawOffset:null }
    }
  }


  async getTimeZonesFromLatLong(lat: number, lng: number): Promise<string[]> {
    const url = `${this.api}/get-timezone-id-from-lat-lng` // returns a list of timezone ids in case lat / lng on border of two timezones.  Not sure why google's api is more accurate / only returns one always
    const timezones = await this.http.post(url, { lat, lng }).toPromise() as string[]
    return timezones
  }

  openByPlaceIdOrAddress(address: string, place_id?: string) {
    if (!address || !place_id) throw new Error('Location has no place_id or address!')
    const url = this.sanitizer.sanitize(SecurityContext.URL, `https://www.google.com/maps/search/?api=1${address ? '&query=' + encodeURI(address) : ''}${place_id ? '&query_place_id=' + place_id : ''}`)
    console.log({ url, place_id, address })
    publicHelpers.openInNewTab(url)
  }

  async findPlacesFromTextWithGoogle(query: string, fields = ['formatted_address', 'name', 'place_id', 'geometry.location']): Promise<PlaceResult[] | {error:string}> {
    const request = { query, fields }
    try {
      const results = await this.findPlacesFromQuery(request)
      console.log({ GOOGLE_RESULTS: results, query })
      if (!results) return []
      return results.map(({ place_id, formatted_address, name, geometry }) => { 
        const { lat, lng } = geometry.location
        return { place_id, formatted_address, name, latitude: lat(), longitude: lng() }
      })      
    } catch (error) {
      console.log(error)
      return {error} 
    }
  }
}


